<!--loader / not-supported-->
<div class="f-1-0 flex-column centralize" *ngIf="!isThisFeatureSupported">
	<loader height="100" width="100" style="opacity: 0.8;" *ngIf="_.isUndefined(isThisFeatureSupported)"></loader>
	<collaboration-protection-not-supported style="display: contents;" *ngIf="isThisFeatureSupported === false"></collaboration-protection-not-supported>
</div>

<popup-c class="bs-enabled" *ngIf="cloudCredentialsPopup?.show"
		 head="Configure sovereign cloud credentials" size="dynamic"
		 (closeCb)="cloudCredentialsPopup.show = false;"
		 (confirmCb)="saveSovereignCloud()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Save', disabled: cloudCredentialsPopup.applyInProcess || actionInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
			<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
			Disconnect before changing the cloud or app registration. The tenant is detected during consent.
		</div>
		<div class="align-items-center flex-row gap-3">
			<div style="min-width: 160px;">Client ID</div>
			<input type="text" placeholder="Client ID" style="width:330px;" [required]="true" [(ngModel)]="cloudCredentialsPopup.clientIdInput"/>
		</div>
		<div class="align-items-center flex-row gap-3">
			<div style="min-width: 160px;">Client secret</div>
			<input type="password" placeholder="Client secret" style="width:330px;" [required]="!cloudCredentialsPopup.clientSecretSet" [(ngModel)]="cloudCredentialsPopup.clientSecretInput"/>
		</div>
		<span *ngIf="cloudCredentialsPopup.clientSecretSet" style="font-size: 12px;">Leave a secret blank only when keeping the same cloud and that app's client ID.</span>
		<p class="text-warning" role="note" *ngIf="cloudCredentialsPopup.endpoint.name === dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name">Processing GCC High data on Trustifi infrastructure may conflict with your FedRAMP or ITAR requirements. Confirm suitability with your compliance team before connecting.</p>
	</div>
</popup-c>

<!-- Setup page — feature supported -->
<div class="collab-config-page flex-column gap-4 animated fadeIn bs-enabled" *ngIf="isThisFeatureSupported && config?.collaboration_protection">
		<!-- Step Cards -->
	<div class="step-cards">

		<!-- Step 1: Connect -->
		<div class="step-card" [class.step-active]="!config.collaboration_protection.microsoft.enabled" [class.step-done]="config.collaboration_protection.microsoft.enabled">
			<div class="step-card-header">
				<div class="step-icon" [class.done]="config.collaboration_protection.microsoft.enabled">
					<i class="far fa-check" *ngIf="config.collaboration_protection.microsoft.enabled"></i>
					<i class="fab fa-microsoft" *ngIf="!config.collaboration_protection.microsoft.enabled"></i>
				</div>
				<div class="step-card-title">
					<div class="step-title-row">
						<h3>Connect Microsoft 365</h3>
						<span class="step-chip" [class.chip-required]="!config.collaboration_protection.microsoft.enabled" [class.chip-done]="config.collaboration_protection.microsoft.enabled">
							<i class="far fa-check-circle" *ngIf="config.collaboration_protection.microsoft.enabled"></i>
							{{ config.collaboration_protection.microsoft.enabled ? 'Connected' : 'Action Required' }}
						</span>
					</div>
					<p>Authenticate with your Microsoft 365 global admin account via Microsoft's secure OAuth flow.</p>
				</div>
			</div>
			<div class="step-card-body">
				<div class="step-actions-row">
					<btn-c [startIcon]="'fab fa-microsoft'"
						   *ngIf="!config.collaboration_protection.microsoft.enabled"
						   (action)="connectMicrosoft()"
						   [loading]="actionInProcess">
						Connect to Microsoft 365
					</btn-c>
					<btn-c [startIcon]="'fab fa-microsoft'"
					       *ngIf="config.collaboration_protection.microsoft.enabled"
					       (action)="reauthenticateMicrosoft()"
					       [loading]="actionInProcess">
						Reauthenticate Microsoft 365
					</btn-c>
					<btn-c class="danger-btn"
						   variant="outlined"
						   startIcon="far fa-unlink"
						   color="#FF0000"
						   *ngIf="config.collaboration_protection.microsoft.enabled"
						   (action)="disconnectMicrosoft()"
						   [isDisabled]="actionInProcess">
						Disconnect
					</btn-c>
				</div>
<!--				<div class="flex-row gap-4">
					<div class="w-50 flex-column gap-2">
						<span style="font-weight: 500;">Cloud API endpoint</span>
						<span style="font-size: 12px; max-width: 300px;">{{config.exchangeConnected ? 'Using the cloud and app from your connected Exchange integration.' : 'Select your Microsoft cloud and enter one client ID and secret for Collaboration protection and site setup.'}}</span>
					</div>
					<div class="w-50">
						<span *ngIf="config.exchangeConnected">{{selectedServerEndpoint.name}}</span>
						<div class="flex-column gap-2" *ngIf="!config.exchangeConnected">
							<app-dropdown-c style="width: 210px; &#45;&#45;bs-dropdown-max-height: 180px; &#45;&#45;bs-dropdown-overflow: auto; display: block;" [text]="selectedServerEndpoint.name">
								<li *ngFor="let entry of dic.CONSTANTS.exchangeServerEndpoints | keyvalue"
									[style.display]="entry.key === 'Hybrid' ? 'none' : null"
									(click)="changeEndpoint(entry.value)">
									{{ entry.value.name }}
								</li>
							</app-dropdown-c>
							<btn-c *ngIf="selectedServerEndpoint.name !== dic.CONSTANTS.exchangeServerEndpoints.Global.name && selectedServerEndpoint.name !== dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCC.name" (action)="changeEndpoint(selectedServerEndpoint)" [isDisabled]="actionInProcess">Edit app credentials</btn-c>
						</div>
					</div>
				</div>
				<p class="text-warning" role="note" *ngIf="selectedServerEndpoint.name === dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name">Processing GCC High data on Trustifi infrastructure may conflict with your FedRAMP or ITAR requirements. Confirm suitability with your compliance team before connecting.</p>
				<p class="security-note" *ngIf="!config.collaboration_protection.microsoft.enabled">
					<i class="far fa-lock"></i>
					Your Microsoft password is not shared with Trustifi. Authentication uses OAuth 2.0.
				</p>-->
			</div>
		</div>

		<!-- Step 2: Discover / Loading data -->
		<div class="step-card"
			 [class.step-pending]="!config.collaboration_protection.microsoft.enabled"
			 [class.step-done]="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.sync_mode === 'done'"
			 [class.step-active]="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.sync_mode !== 'done'">
			<div class="step-card-header">
				<div class="step-icon"
					 [class.done]="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.sync_mode === 'done'"
					 [class.pending]="!config.collaboration_protection.microsoft.enabled">
					<i class="far fa-check" *ngIf="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.sync_mode === 'done'"></i>
					<i class="far fa-sitemap" *ngIf="!config.collaboration_protection.microsoft.enabled || config.collaboration_protection.microsoft.sync_mode !== 'done'"></i>
				</div>
				<div class="step-card-title">
					<div class="step-title-row">
						<h3>Load Your Environment</h3>
						<span class="step-chip chip-done" *ngIf="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.sync_mode === 'done'">
							<i class="far fa-check-circle"></i> Completed
						</span>
					</div>
					<p>Trustifi automatically maps all users, channels, and resources across your Microsoft 365 tenant.</p>
				</div>
			</div>

			<div class="step-card-body" *ngIf="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.sync_mode">
				<!-- Sync progress (reused from sync-status-card below, inline here) -->
				<div class="sync-progress">
					<div class="sync-step"
						 [class.sync-step-active]="getSyncStepState('chat') === 'active'"
						 [class.sync-step-done]="getSyncStepState('chat') === 'done'">
						<div class="sync-step-indicator">
							<i class="far fa-check" *ngIf="getSyncStepState('chat') === 'done'"></i>
							<i class="far fa-spinner fa-spin" *ngIf="getSyncStepState('chat') === 'active'"></i>
						</div>
						<div class="sync-step-label"><i class="far fa-comments"></i> Chats &amp; Meetings</div>
					</div>
					<div class="sync-connector" [class.sync-connector-done]="getSyncStepState('channel') !== 'pending'"></div>
					<div class="sync-step"
						 [class.sync-step-active]="getSyncStepState('channel') === 'active'"
						 [class.sync-step-done]="getSyncStepState('channel') === 'done'">
						<div class="sync-step-indicator">
							<i class="far fa-check" *ngIf="getSyncStepState('channel') === 'done'"></i>
							<i class="far fa-spinner fa-spin" *ngIf="getSyncStepState('channel') === 'active'"></i>
						</div>
						<div class="sync-step-label"><i class="far fa-hashtag"></i> Channels</div>
					</div>
					<div class="sync-connector" [class.sync-connector-done]="getSyncStepState('site') !== 'pending'"></div>
					<div class="sync-step"
						 [class.sync-step-active]="getSyncStepState('site') === 'active'"
						 [class.sync-step-done]="getSyncStepState('site') === 'done'">
						<div class="sync-step-indicator">
							<i class="far fa-check" *ngIf="getSyncStepState('site') === 'done'"></i>
							<i class="far fa-spinner fa-spin" *ngIf="getSyncStepState('site') === 'active'"></i>
						</div>
						<div class="sync-step-label"><i class="far fa-globe"></i> Sites</div>
					</div>
				</div>
			</div>
			<div class="step-card-body" *ngIf="!config.collaboration_protection.microsoft.enabled">
				<div class="asset-chips">
					<span class="asset-chip"><i class="far fa-users"></i> Users</span>
					<span class="asset-chip"><i class="far fa-comments"></i> Teams</span>
					<span class="asset-chip"><i class="far fa-file-alt"></i> SharePoint</span>
					<span class="asset-chip"><i class="far fa-cloud"></i> OneDrive</span>
				</div>
			</div>
		</div>

		<!-- Step 3: Select Protection Scope -->
		<div class="step-card" [class.step-pending]="!config.collaboration_protection.microsoft.enabled || config.collaboration_protection.microsoft.sync_mode !== 'done'" [class.step-done]="isProtectionScopeCompleted">
			<div class="step-card-header">
				<div class="step-icon" [class.done]="isProtectionScopeCompleted">
					<i class="far fa-check" *ngIf="isProtectionScopeCompleted"></i>
					<i class="far fa-users" *ngIf="!isProtectionScopeCompleted"></i>
				</div>
				<div class="step-card-title">
					<div class="step-title-row">
						<h3>Select Protection Scope</h3>
						<span class="step-chip chip-done" *ngIf="isProtectionScopeCompleted">
							<i class="far fa-check-circle"></i> Completed
						</span>
					</div>
					<p>Choose who in your tenant should be protected by Collaboration Protection.</p>
				</div>
			</div>
			<div class="step-card-body">
				<div class="scope-options flex-column gap-2">
					<label class="scope-option" [class.scope-selected]="protectionScope === 'all'">
						<input type="radio" name="protectionScope" [(ngModel)]="protectionScope" value="all" (change)="protectionScopeChanged = true">
						<div class="scope-option-body">
							<span class="scope-option-title">All users in the tenant</span>
							<span class="scope-option-desc">Every user in your Microsoft 365 directory will be covered.</span>
						</div>
					</label>
					<label class="scope-option" [class.scope-selected]="protectionScope === 'specific'">
						<input type="radio" name="protectionScope" [(ngModel)]="protectionScope" value="specific" (change)="protectionScopeChanged = true">
						<div class="flex-row gap-3 align-items-center">
							<div class="scope-option-body">
								<span class="scope-option-title">Select specific users</span>
								<span class="scope-option-desc">Select users to protect. Manage them on the <a class="blue-link" (click)="goToUsersPage()">Users &amp; Resources page</a>.</span>
							</div>
							<app-dropdown-c style="width: 250px; --dropdown-menu-width: 350px;"
											[isDisabled]="!mailboxes.length || protectionScope !== 'specific'"
											(click)="$event.preventDefault();"
											[items]="mailboxes"
											(onItemClicked)="protectionScope = 'specific'; isMailboxesError = false; protectionScopeChanged = true;"
											[isMultipleSelection]="true"
											[enableSearch]="true"
											[error]="isMailboxesError"
											itemDisplayKey="displayName">
							</app-dropdown-c>
						</div>
					</label>
				</div>
				<btn-c class="mt-3"
					   (action)="saveProtectionScope()"
					   [isDisabled]="actionInProcess || !protectionScopeChanged">
					Confirm
				</btn-c>
			</div>
		</div>

		<!-- Step 4: Initial Scan & Activation -->
		<div class="step-card"
			 [class.step-pending]="!config.collaboration_protection.microsoft.enabled || !isProtectionScopeCompleted"
			 [class.step-done]="config.collaboration_protection.microsoft.enabled && isProtectionScopeCompleted && config.collaboration_protection.microsoft.historical_scan?.status && !historicalScanInProcess">
			<div class="step-card-header">
				<div class="step-icon"
					 [class.done]="config.collaboration_protection.microsoft.enabled && isProtectionScopeCompleted && config.collaboration_protection.microsoft.historical_scan?.status && !historicalScanInProcess"
					 [class.pending]="!config.collaboration_protection.microsoft.enabled || !isProtectionScopeCompleted || !config.collaboration_protection.microsoft.historical_scan?.status || historicalScanInProcess">
					<i class="far fa-check" *ngIf="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.historical_scan?.status && !historicalScanInProcess"></i>
					<i class="fas fa-search" *ngIf="!config.collaboration_protection.microsoft.historical_scan?.status || historicalScanInProcess"></i>
				</div>
				<div class="step-card-title">
					<div class="step-title-row">
						<h3>Initial Scan</h3>
						<span class="step-chip chip-done" *ngIf="config.collaboration_protection.microsoft.enabled && config.collaboration_protection.microsoft.historical_scan?.status === 'completed'">
							<i class="far fa-check-circle"></i> Completed
						</span>
					</div>
					<p>Run a historical scan of the last 7 days.</p>
				</div>

			</div>
			<div class="step-card-body" *ngIf="config.collaboration_protection.microsoft.enabled">
				<div class="flex-row align-items-center gap-4">
					<div class="flex-column gap-3" style="font-size: 14px; max-width: 460px;">
						<div class="flxRow gap-2 animated fadeIn" style="align-items: center" *ngIf="config.collaboration_protection.microsoft.historical_scan?.status">
							<div class="sync-step animated fadeIn"
								 *ngIf="historicalScanInProcess"
								 [class.sync-step-active]="historicalScanInProcess">
								<div class="sync-step-indicator">
									<i class="far fa-spinner fa-spin"></i>
								</div>
							</div>
							<div class="flex-column f-1-0 gap-1" *ngIf="historicalScanInProcess">
								<div class="flex-row justify-content-between align-items-center">
									<span class="scan-label loading-dots">Scanning</span>
									<span class="scan-label" *ngIf="config.collaboration_protection.microsoft.historical_scan.resources_total">
										{{config.collaboration_protection.microsoft.historical_scan.resources_scanned || 0}} / {{config.collaboration_protection.microsoft.historical_scan.resources_total}} resources scanned
									</span>
								</div>
								<div class="scan-bar-track">
									<div class="scan-bar-fill" style="width: 100%; max-width: 0; transition: max-width 1s ease-out;"
										 [style.max-width]="((config.collaboration_protection.microsoft.historical_scan.resources_scanned || 0) / (config.collaboration_protection.microsoft.historical_scan.resources_total || 100)) * 100 + '%'">
									</div>
								</div>
							</div>
							<div class="scan-label w-100 flxRow-between animated fadeIn" *ngIf="config.collaboration_protection.microsoft.historical_scan?.status === 'completed'">
								<span style="font-size: 14px;">Historical scan completed!</span>
								<span class="fw-normal" *ngIf="config.collaboration_protection.microsoft.historical_scan.resources_total > 0">Total resources scanned: <b>{{config.collaboration_protection.microsoft.historical_scan.resources_total}}</b></span>
							</div>
							<span class="scan-label flxClmn animated fadeIn" *ngIf="config.collaboration_protection.microsoft.historical_scan?.status === 'skip'">Historical scan skipped.</span>
						</div>
						<div class="flex-row gap-3 flex-wrap justify-content-start animated fadeIn" *ngIf="config.collaboration_protection.microsoft.historical_scan?.status === 'completed' || historicalScanInProcess">
							<div class="flex-row gap-3 border p-3 rounded-3 bg-white shadow-sm" style="flex: 1 0 45%; --bs-bg-opacity: 0.85;">
								<div class="bg-light rounded-2 p-2 d-flex centralize" style="width: 40px; height: 40px;">
									<i class="far fa-envelope text-muted" style="font-size: 1.3rem;"></i>
								</div>
								<div class="flex-column f-1-0">
									<h5 class="m-0">{{config.collaboration_protection.microsoft.historical_scan.messages_scanned}}</h5>
									<span>Messages scanned</span>
								</div>
							</div>
							<div class="flex-row gap-3 border p-3 rounded-3 bg-white shadow-sm" style="flex: 1 0 45%; --bs-bg-opacity: 0.85;">
								<div class="bg-light rounded-2 p-2 d-flex centralize" style="width: 40px; height: 40px;">
									<i class="far fa-file text-muted" style="font-size: 1.3rem;"></i>
								</div>
								<div class="flex-column f-1-0">
									<h5 class="m-0">{{config.collaboration_protection.microsoft.historical_scan.files_scanned}}</h5>
									<span>Files scanned</span>
								</div>
							</div>

							<div class="flex-row gap-3 border p-3 rounded-3 bg-white shadow-sm" style="flex: 1 0 45%; --bs-bg-opacity: 0.85;">
								<div class="bg-danger rounded-2 p-2 d-flex centralize" style="--bs-bg-opacity: 0.12; width: 40px; height: 40px;">
									<i class="far fa-exclamation-triangle text-danger" style="font-size: 1.3rem;"></i>
								</div>
								<div class="flex-column f-1-0">
									<h5 class="m-0">{{config.collaboration_protection.microsoft.historical_scan.dlp_detected}}</h5>
									<span>DLP violations</span>
								</div>
							</div>
							<div class="flex-row gap-3 border p-3 rounded-3 bg-white shadow-sm" style="flex: 1 0 45%; --bs-bg-opacity: 0.85;">
								<div class="bg-danger rounded-2 p-2 d-flex centralize" style="--bs-bg-opacity: 0.12; width: 40px; height: 40px;">
									<i class="far fa-bug text-danger" style="font-size: 1.3rem;"></i>
								</div>
								<div class="flex-column f-1-0">
									<h5 class="m-0">{{config.collaboration_protection.microsoft.historical_scan.malicious_detected}}</h5>
									<span>Malicious content</span>
								</div>
							</div>
						</div>
					</div>
					<btn-c class="mt-4" style="min-width: 0;" variant="text"
						   endIcon="far fa-chevron-right"
						   (click)="goToOverviewPage();"
						   *ngIf="config.collaboration_protection.microsoft.historical_scan?.status === 'completed' || historicalScanInProcess">
						View full overview
					</btn-c>
				</div>
				<div class="flxRow gap-4 mt-3" *ngIf="!config.collaboration_protection.microsoft.historical_scan?.status && !historicalScanInProcess">
					<btn-c (action)="startHistoryScan();">
						Start Scan
					</btn-c>
					<btn-c (action)="skipHistoryScan();" variant="text">Skip This Step</btn-c>
				</div>
			</div>
		</div>

	</div>

	<!-- Support Banner -->
	<div class="support-banner">
		<i class="far fa-headset"></i>
		<span>Need help with the setup?</span>
		<a class="blue-link"
		   [routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets]"
		   [state]="{ data: 'open' }">Contact Support</a>
	</div>

</div>
